module.exports = __webpack_public_path__ + "static/img/The_Buy_Side_Experience_With_SRG@2x.de8fc6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/The_Buy_Side_Experience_With_SRG@2x.png
// module id = E5gB
// module chunks = 0